import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Button } from '@mui/material';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import { usePets } from '../../../hooks/patients/usePets';
import { Box, List, IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchBox from '../../common/forms/SearchBox';
import { Divider } from '@mui/material';
import PatientSummary from './PatientSummary';

export default function PatientSummarySearch({autoOpen = false}) {

    const [open, setOpen] = React.useState(false);
    const handleClickOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        resetParent();
    };

    const [selectedPet, setSelectedPet] = React.useState(null);
    const [viewOpen, setViewOpen] = React.useState(false);

    const { pets, loading, loadMore, searchFunction, resetParent } = usePets(open, 1, 10);

    const handleListItemClick = (pet) => {
        setSelectedPet(pet);
        setViewOpen(true);
    };

    React.useEffect(() => {
      if (autoOpen) {
        setOpen(true);
      }
    }, []);
    return (
        <>
        <ListItem>
            <ListItemButton onClick={handleClickOpen}>
            <ListItemIcon>
                <ContentPasteSearchIcon fontSize='large' color='secondary' />
            </ListItemIcon>
            <ListItemText 
                primary="Patient Medical History"
                secondary="search patient medical history"
            />
            </ListItemButton>
        </ListItem>

        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
                <Stack spacing={2}>
                    <Typography variant="h6">Search Patient Medical History</Typography>
                    <SearchBox searchFunction={searchFunction} resetParent={resetParent} autoFocus={false} />
                    <Divider />
                </Stack>
            </DialogTitle>
            <DialogContent>
                <List sx={{ minHeight: 500 }}>
                    {pets?.data?.map((pet) => (
                    <ListItem
                        key={pet.id}
                    >
                        <ListItemButton onClick={() => handleListItemClick(pet)}>
                            <ListItemIcon>
                                <PendingActionsIcon fontSize='large' color='primary' />
                            </ListItemIcon>
                            <ListItemText
                            primary={`${pet.name}`}
                            secondary={`${pet.owner.first_name} ${pet.owner.last_name}`}
                            />
                        </ListItemButton>
                    </ListItem>
                    ))}
                </List>

                {/* Load More only shows if more pages exist */}
                {pets?.pagination?.page < pets?.pagination?.totalPages && (
                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                        <IconButton 
                            onClick={loadMore}
                            sx={{
                                width: '100%',              // fill container width
                                justifyContent: 'center',   // center the icon horizontally
                                color: 'primary.main',      // use theme's primary color
                            }}
                        >
                            <KeyboardArrowDownIcon />
                        </IconButton>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                {autoOpen ? null : <Button onClick={handleClose}>Close</Button>} 
            </DialogActions>
        </Dialog>
        <PatientSummary 
            pet={selectedPet}
            open={viewOpen}
            onClose={() => setViewOpen(false)}
        />
        </>
    );
}